import { render, staticRenderFns } from "./CodPostalesList.vue?vue&type=template&id=700d4a47&scoped=true&"
import script from "./CodPostalesList.vue?vue&type=script&lang=js&"
export * from "./CodPostalesList.vue?vue&type=script&lang=js&"
import style0 from "./CodPostalesList.vue?vue&type=style&index=0&id=700d4a47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d4a47",
  null
  
)

export default component.exports